import { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import MUIDrawer from '@material-ui/core/Drawer';
import PropTypes from 'prop-types';
import ArrowBack from '@icon/ArrowBack';
import Close from '@icon/Close';
import imageHelper from '@utils/imageHelper';
import { Spacings } from '@styles/index';

const StyledDrawer = styled(MUIDrawer)`
  &.MuiDrawer-root > .MuiPaper-root {
    background-color: ${({ theme, backgroundColor }) =>
      backgroundColor || theme.colors.base};
    display: grid;
    grid-template-columns: repeat(10, ${Spacings.SPACING_8B});
    grid-column-gap: ${Spacings.SPACING_4B};
    grid-auto-rows: max-content;
    padding-left: ${({ $withOutPadding }) =>
      $withOutPadding ? 0 : Spacings.SPACING_12B};
    padding-top: ${({ $withOutPadding }) =>
      $withOutPadding ? 0 : Spacings.SPACING_6B};
    padding-right: ${({ $withOutPadding }) => ($withOutPadding ? 0 : '115px')};
    overflow-x: hidden;
    background-image: ${({ $imageURL }) =>
      $imageURL && `url(${imageHelper.getImage($imageURL)})`};
    background-position: ${({ $imagePosition }) => $imagePosition};
    background-repeat: no-repeat;
    background-size: ${({ $imageSize }) => $imageSize};
    background-attachment: ${({ backgroundAttachment }) =>
      backgroundAttachment};
    @media (max-width: 47.95em) {
      width: 100%;
      padding-left: ${({ $withOutPadding }) =>
        $withOutPadding ? 0 : Spacings.SPACING_4B};
      padding-right: ${({ $withOutPadding }) =>
        $withOutPadding ? 0 : Spacings.SPACING_4B};
      overflow-x: initial;
      grid-template-columns: repeat(10, 1fr);
    }
    ${({ $login, $hideCloseButton }) => {
      return (
        !$hideCloseButton && `grid-template-rows: 60px ${$login ? '1fr' : ''};`
      );
    }}
  }
`;

const CloseWrapper = styled.div`
  grid-column: 1/11;
  cursor: pointer;
`;

const Drawer = ({
  children,
  backgroundColor,
  withOutPadding,
  drawerState,
  onClose,
  hideCloseButton,
  showBackButton,
  onPressBack,
  imageURL,
  imagePosition,
  imageSize,
  backgroundAttachment,
  disableBackdropClick,
  disableEscapeKeyDown,
  login
}) => {
  const theme = useContext(ThemeContext);
  return (
    <StyledDrawer
      anchor="right"
      backgroundColor={backgroundColor}
      open={drawerState}
      onClose={onClose}
      PaperProps={{ id: 'DrawerPaper' }}
      $imageURL={imageURL}
      $imagePosition={imagePosition}
      $imageSize={imageSize}
      backgroundAttachment={backgroundAttachment}
      disableEscapeKeyDown={disableEscapeKeyDown}
      disableBackdropClick={disableBackdropClick}
      $withOutPadding={withOutPadding}
      $login={login}
      $hideCloseButton={hideCloseButton}
    >
      {!hideCloseButton && (
        <CloseWrapper>
          <Close size="24px" onClick={onClose} color={theme.colors.fontGrey} />
        </CloseWrapper>
      )}
      {showBackButton && (
        <CloseWrapper>
          <ArrowBack
            size="24px"
            onClick={onPressBack}
            color={theme.colors.fontGrey}
          />
        </CloseWrapper>
      )}
      {children}
    </StyledDrawer>
  );
};

export default Drawer;

Drawer.propTypes = {
  children: PropTypes.node.isRequired,
  backgroundColor: PropTypes.string,
  withOutPadding: PropTypes.bool,
  drawerState: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  hideCloseButton: PropTypes.bool,
  showBackButton: PropTypes.bool,
  onPressBack: PropTypes.func,
  imageURL: PropTypes.string,
  imagePosition: PropTypes.string,
  imageSize: PropTypes.string,
  backgroundAttachment: PropTypes.string,
  disableEscapeKeyDown: PropTypes.bool,
  disableBackdropClick: PropTypes.bool,
  login: PropTypes.bool
};

Drawer.defaultProps = {
  backgroundColor: null,
  withOutPadding: false,
  drawerState: false,
  hideCloseButton: false,
  showBackButton: false,
  onPressBack: null,
  imageURL: null,
  imagePosition: null,
  imageSize: null,
  backgroundAttachment: null,
  disableEscapeKeyDown: false,
  disableBackdropClick: false,
  login: false
};
